/**
 * MontiPower Shopify Theme — theme.js
 * Handles: nav, FAQ accordion, scroll animations, product image swap,
 *          filter tabs, form UX, sticky header, cookie banner
 */

(function () {
  'use strict';

  var T = (window.MP_I18N && window.MP_I18N.theme_js) || {};

  /* ── Sticky header shadow ─────────────────────────────────── */
  const header = document.getElementById('site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Mobile nav toggle ────────────────────────────────────── */
  const navToggle = document.getElementById('nav-toggle');
  const mainNav   = document.getElementById('main-nav');
  if (navToggle && mainNav) {
    navToggle.addEventListener('click', () => {
      const isOpen = mainNav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', String(isOpen));
      const iconOpen  = navToggle.querySelector('.icon-open');
      const iconClose = navToggle.querySelector('.icon-close');
      if (iconOpen)  iconOpen.style.display  = isOpen ? 'none'  : '';
      if (iconClose) iconClose.style.display = isOpen ? ''      : 'none';
    });
    // Close nav on outside click
    document.addEventListener('click', (e) => {
      if (!header.contains(e.target)) {
        mainNav.classList.remove('is-open');
        navToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ── Nav dropdowns (desktop keyboard + hover) ─────────────── */
  document.querySelectorAll('.nav-item--has-dropdown').forEach(item => {
    const toggle = item.querySelector('.nav-item__link');
    const dropdown = item.querySelector('.nav-dropdown');
    if (!toggle || !dropdown) return;

    // Toggle on click (mobile / keyboard)
    toggle.addEventListener('click', (e) => {
      if (window.innerWidth <= 900) {
        e.preventDefault();
        const expanded = dropdown.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(expanded));
      }
    });

    // Keyboard accessibility
    toggle.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        dropdown.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  });

  /* ── FAQ accordion ────────────────────────────────────────── */
  document.querySelectorAll('.faq-item__question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item   = btn.closest('.faq-item');
      const answer = item.querySelector('.faq-item__answer');
      const isOpen = item.classList.contains('is-open');

      // Close all others
      document.querySelectorAll('.faq-item.is-open').forEach(open => {
        open.classList.remove('is-open');
        open.querySelector('.faq-item__question').setAttribute('aria-expanded', 'false');
        const ans = open.querySelector('.faq-item__answer');
        if (ans) ans.style.maxHeight = '0';
      });

      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        if (answer) answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  /* ── Product filter tabs ──────────────────────────────────── */
  const filterBar = document.querySelector('.filter-bar');
  if (filterBar) {
    const tabs  = filterBar.querySelectorAll('.filter-tab');
    const cards = document.querySelectorAll('#product-grid > *');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        const filter = tab.dataset.filter;
        cards.forEach(card => {
          const tags = (card.dataset.tags || '').split(',').map(t => t.trim().toLowerCase());
          card.style.display = (filter === 'all' || tags.includes(filter)) ? '' : 'none';
        });
      });
    });
  }

  /* ── Product image thumbnail swap + zoom button ─────────── */
  const featuredImg  = document.getElementById('product-featured-image');
  const lightbox     = document.getElementById('product-lightbox');
  const lightboxImg  = document.getElementById('lightbox-img');
  const lightboxClose= document.getElementById('lightbox-close');
  const zoomBtn      = document.getElementById('product-zoom-btn');

  function openLightbox(zoomUrl, alt) {
    if (!lightbox || !lightboxImg) return;
    lightboxImg.src = zoomUrl;
    lightboxImg.alt = alt || '';
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    lightboxClose && lightboxClose.focus();
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.body.style.overflow = '';
    zoomBtn && zoomBtn.focus();
  }

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightbox) {
    lightbox.addEventListener('click', (e) => { if (e.target === lightbox) closeLightbox(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !lightbox.hidden) closeLightbox(); });
  }
  if (zoomBtn && featuredImg) {
    zoomBtn.addEventListener('click', () => openLightbox(featuredImg.dataset.zoom || featuredImg.src, featuredImg.alt));
  }
  if (featuredImg) {
    featuredImg.addEventListener('click', () => openLightbox(featuredImg.dataset.zoom || featuredImg.src, featuredImg.alt));
    featuredImg.style.cursor = 'zoom-in';
  }

  // Thumbnail swap — also updates zoom URL
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.product-thumb').forEach(t => {
        t.classList.remove('active');
        t.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('active');
      thumb.setAttribute('aria-pressed', 'true');
      if (featuredImg) {
        featuredImg.src = thumb.dataset.imageUrl;
        if (thumb.dataset.zoomUrl) featuredImg.dataset.zoom = thumb.dataset.zoomUrl;
      }
    });
  });

  /* ── Product variant selector ─────────────────────────────── */
  const variantIdInput = document.getElementById('product-variant-id');
  const skuEl          = document.getElementById('product-sku');
  const priceEl        = document.getElementById('product-price');

  // Shopify injects product JSON via script tag — read it
  const productJsonEl = document.getElementById('product-json');
  let productData = null;
  if (productJsonEl) {
    try { productData = JSON.parse(productJsonEl.textContent); } catch(e) {}
  }

  // Track selected options
  const selectedOptions = {};

  document.querySelectorAll('.option-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const idx   = btn.dataset.optionIndex;
      const value = btn.dataset.optionValue;

      // Update active state within this option group
      document.querySelectorAll(`.option-btn[data-option-index="${idx}"]`).forEach(b => {
        b.classList.remove('active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-pressed', 'true');

      // Update displayed label
      const labelEl = document.getElementById(`option-val-${parseInt(idx)+1}`);
      if (labelEl) labelEl.textContent = value;

      selectedOptions[idx] = value;

      // Find matching variant
      if (productData) {
        const selectedValues = Object.keys(selectedOptions).sort().map(k => selectedOptions[k]);
        const match = productData.variants.find(v => {
          return v.options.every((opt, i) => {
            const key = String(i);
            return !selectedOptions[key] || selectedOptions[key] === opt;
          });
        });
        if (match) {
          if (variantIdInput) variantIdInput.value = match.id;
          if (skuEl && match.sku)   skuEl.textContent = 'SKU: ' + match.sku;
          // Only update the visible price if pricing is NOT gated.
          // When gated, the locked-price block stays untouched.
          var priceVisible = priceEl && priceEl.querySelector('.b2b-price--visible, .price');
          if (priceEl && priceVisible && !priceEl.querySelector('.b2b-price--gated')) {
            if (match.price === 0) {
              priceEl.innerHTML = '<span class="price-note">' + (T.ask_for_price || 'Zapytaj o cenę') + '</span>';
            } else {
              var amt = (match.price / 100).toFixed(2);
              var _p = amt.split('.');
              _p[0] = _p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              var formatted = (window.MP_MONEY_FORMAT || '{{amount}} zł').replace(/\{\{\s*amount\s*\}\}/, _p.join('.'));
              priceEl.innerHTML = '<span class="b2b-price b2b-price--visible">' + formatted + '</span>';
            }
          }
        }
      }
    });
    // Initialise selectedOptions from active state
    if (btn.classList.contains('active')) {
      selectedOptions[btn.dataset.optionIndex] = btn.dataset.optionValue;
    }
  });

  /* ── Scroll reveal (fade-up) ──────────────────────────────── */
  const fadeEls = document.querySelectorAll('.fade-up');
  if (fadeEls.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    fadeEls.forEach(el => observer.observe(el));
  }

  /* ── Smooth scroll for anchor links ──────────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const offset = header ? header.offsetHeight + 16 : 80;
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
      }
    });
  });

  /* ── Contact form: pre-fill industry from URL param ───────── */
  const industryParam = new URLSearchParams(window.location.search).get('industry');
  if (industryParam) {
    const sel = document.getElementById('ContactForm-industry');
    if (sel) {
      const opt = Array.from(sel.options).find(o => o.value === industryParam);
      if (opt) sel.value = industryParam;
    }
  }

  /* ── Cookie banner ────────────────────────────────────────── */
  const banner  = document.getElementById('cookie-banner');
  const btnAccept  = document.getElementById('cookie-accept');
  const btnDecline = document.getElementById('cookie-decline');
  if (banner) {
    const consent = localStorage.getItem('mp_cookie_consent');
    if (!consent) banner.style.display = '';
    if (btnAccept)  btnAccept.addEventListener('click',  () => { localStorage.setItem('mp_cookie_consent','accepted');  banner.style.display = 'none'; });
    if (btnDecline) btnDecline.addEventListener('click', () => { localStorage.setItem('mp_cookie_consent','declined'); banner.style.display = 'none'; });
  }

  /* ── FAQ CSS: ensure max-height starts at 0 ──────────────── */
  document.querySelectorAll('.faq-item__answer').forEach(el => {
    el.style.maxHeight   = '0';
    el.style.overflow    = 'hidden';
    el.style.transition  = 'max-height 0.32s ease';
  });

  /* ── Sticky mobile quote bar (product pages) ─────────────── */
  const stickyBar = document.getElementById('product-sticky-bar');
  const heroActions = document.querySelector('.product-hero__actions');
  if (stickyBar && heroActions) {
    const onStickyScroll = () => {
      const rect = heroActions.getBoundingClientRect();
      // Show once the main action buttons have scrolled out of view (above viewport)
      const show = rect.bottom < 0;
      stickyBar.classList.toggle('is-visible', show);
      stickyBar.setAttribute('aria-hidden', String(!show));
    };
    window.addEventListener('scroll', onStickyScroll, { passive: true });
    onStickyScroll();
  }

  /* ── Prefill contact form from ?product= & ?subject= ─────── */
  const cParams = new URLSearchParams(window.location.search);
  const productParam = cParams.get('product');
  if (productParam) {
    // Try to match the product dropdown option, else drop it into the message
    const prodSelect = document.getElementById('ContactForm-product');
    const bodyField = document.getElementById('ContactForm-body')
      || document.querySelector('textarea[name="contact[body]"]');
    let matched = false;
    if (prodSelect) {
      const opt = Array.from(prodSelect.options)
        .find(o => o.value.toLowerCase().includes(productParam.toLowerCase())
                || o.text.toLowerCase().includes(productParam.toLowerCase()));
      if (opt) { prodSelect.value = opt.value; matched = true; }
    }
    if (bodyField && !bodyField.value) {
      bodyField.value = (T.prefill_quote_body || 'Proszę o wycenę produktu: ') + productParam + '\n\n';
    }
    // Also stash SKU as a hidden field so it reaches your inbox even if unmatched
    const form = (prodSelect && prodSelect.form) || (bodyField && bodyField.form);
    if (form && !matched) {
      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'contact[product_sku]';
      hidden.value = productParam;
      form.appendChild(hidden);
    }
  }

})();



/* ============================================================
   AJAX CART + DRAWER  (added in v1.2.0)
   ============================================================ */
(function () {
  'use strict';

  var T = (window.MP_I18N && window.MP_I18N.theme_js) || {};
  var drawer    = document.getElementById('cart-drawer');
  var drawerBody= document.getElementById('cart-drawer-body');
  var drawerFoot= document.getElementById('cart-drawer-footer');
  var hasDrawer = !!drawer;
  var moneyFormat = (window.MP_MONEY_FORMAT || '{{amount}} zł');

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    // amount with thousands separators
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    value = parts.join('.');
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  /* ── Drawer open / close ──────────────────────────────────── */
  function openDrawer() {
    if (!hasDrawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }
  function closeDrawer() {
    if (!hasDrawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && hasDrawer) { e.preventDefault(); openDrawer(); refreshDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ── Update cart count badges everywhere ──────────────────── */
  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (el.classList.contains('cart-count')) {
        el.style.display = count > 0 ? '' : 'none';
      }
    });
  }
  function updateSubtotals(cents) {
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) {
      el.textContent = formatMoney(cents);
    });
  }

  /* ── Refresh drawer body via Section Rendering API ────────── */
  function refreshDrawer() {
    if (!hasDrawer) return;
    fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .catch(function () { return null; })
      .then(function (html) {
        if (!html) return;
        // Extract body + footer from returned section markup
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var newBody = tmp.querySelector('#cart-drawer-body');
        var newFoot = tmp.querySelector('#cart-drawer-footer');
        if (newBody && drawerBody) drawerBody.innerHTML = newBody.innerHTML;
        if (newFoot && drawerFoot) {
          drawerFoot.innerHTML = newFoot.innerHTML;
          drawerFoot.style.display = newFoot.getAttribute('style') && newFoot.getAttribute('style').indexOf('none') > -1 ? 'none' : '';
        }
      });
  }

  /* ── Fetch cart state and sync UI ─────────────────────────── */
  function syncCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      updateCount(cart.item_count);
      updateSubtotals(cart.total_price);
      return cart;
    });
  }

  /* ── Add to cart (intercept product form) ─────────────────── */
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      // Only AJAX-ify when a drawer exists; otherwise let Shopify navigate to /cart
      if (!hasDrawer) return;
      e.preventDefault();
      var btn = productForm.querySelector('#add-to-cart-btn');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = (T.adding || 'Dodawanie…'); }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: (document.getElementById('product-variant-id') || {}).value,
          quantity: 1
        })
      })
      .then(function (r) { return r.json(); })
      .then(function () { return syncCart(); })
      .then(function () { refreshDrawer(); openDrawer(); })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } });
    });
  }

  /* ── Change line quantity (drawer + cart page) ────────────── */
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      updateCount(cart.item_count);
      updateSubtotals(cart.total_price);
      return cart;
    });
  }

  // Delegate qty steppers + remove for both drawer and cart page
  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-qty-up]');
    var down = e.target.closest('[data-qty-down]');
    var remove = e.target.closest('[data-cart-remove]');

    if (up || down) {
      var stepper = e.target.closest('.qty-stepper');
      var input = stepper && stepper.querySelector('[data-cart-qty]');
      if (!input) return;
      var current = parseInt(input.value, 10) || 0;
      var next = up ? current + 1 : Math.max(0, current - 1);
      input.value = next;
      var key = input.getAttribute('data-key');
      if (key) {
        changeLine(key, next).then(function (cart) {
          if (next === 0 || isCartPage()) { window.location.reload(); }
          else { refreshDrawer(); }
        });
      }
    }

    if (remove) {
      e.preventDefault();
      var rkey = remove.getAttribute('data-cart-remove');
      changeLine(rkey, 0).then(function () {
        if (isCartPage()) window.location.reload();
        else refreshDrawer();
      });
    }
  });

  // Direct typing in qty input (cart page)
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var key = input.getAttribute('data-key');
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    if (key) changeLine(key, qty).then(function () {
      if (isCartPage()) window.location.reload(); else refreshDrawer();
    });
  });

  function isCartPage() {
    return document.body.classList.contains('template-cart');
  }
})();

/* ============================================================
   ADDRESS COUNTRY/PROVINCE SELECTORS (customer addresses)
   ============================================================ */
(function () {
  'use strict';
  if (!document.querySelector('[data-default]')) return;
  // Shopify ships Shopify.CountryProvinceSelector via option_selection.js.
  // Load it if not present, then wire each address form.
  function initSelectors() {
    document.querySelectorAll('select[name="address[country]"]').forEach(function (countrySel) {
      var wrap = countrySel.closest('.form-row') || document;
      var provinceSel = document.getElementById(countrySel.id.replace('country', 'province'));
      var provinceWrap = document.getElementById(countrySel.id.replace('addr-country', 'addr-province-wrap'));
      if (!provinceSel) return;
      function updateProvinces() {
        var opt = countrySel.options[countrySel.selectedIndex];
        var provinces = [];
        try { provinces = JSON.parse(opt.getAttribute('data-provinces') || '[]'); } catch (e) {}
        provinceSel.innerHTML = '';
        if (!provinces.length) {
          if (provinceWrap) provinceWrap.style.display = 'none';
          return;
        }
        if (provinceWrap) provinceWrap.style.display = '';
        provinces.forEach(function (p) {
          var o = document.createElement('option');
          o.value = p[0]; o.textContent = p[1];
          provinceSel.appendChild(o);
        });
        var def = provinceSel.getAttribute('data-default');
        if (def) provinceSel.value = def;
      }
      // Set default country
      var defCountry = countrySel.getAttribute('data-default');
      if (defCountry) countrySel.value = defCountry;
      countrySel.addEventListener('change', updateProvinces);
      updateProvinces();
    });
  }
  initSelectors();
})();

/* ── Product detail tabs (v1.3.1) ──────────────────────────────── */
(function () {
  'use strict';
  function initProductTabs() {
    document.querySelectorAll('[data-pd-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-pd-tab]');
      var panels = root.querySelectorAll('[data-pd-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-pd-tab');
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', String(on));
          });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-pd-panel') === target);
          });
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTabs);
  } else {
    initProductTabs();
  }

  /* Hero "Request a Quote" → smooth scroll to sidebar form + focus */
  function initScrollToQuote() {
    document.querySelectorAll('[data-scroll-to-quote]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var form = document.getElementById('sidebar-enquiry');
        if (!form) return; // fall back to default anchor behavior
        e.preventDefault();
        var card = form.closest('.enquiry-card') || form;
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        card.classList.add('enquiry-card--pulse');
        setTimeout(function () { card.classList.remove('enquiry-card--pulse'); }, 1400);
        var firstField = form.querySelector('input:not([type=hidden]), textarea');
        if (firstField) { setTimeout(function () { firstField.focus({ preventScroll: true }); }, 500); }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollToQuote);
  } else {
    initScrollToQuote();
  }
})();

/* ── Header search toggle (v1.3.8) ─────────────────────────────── */
(function () {
  'use strict';
  function initHeaderSearch() {
    var wrap = document.querySelector('[data-header-search]');
    if (!wrap) return;
    var toggle = wrap.querySelector('[data-search-toggle]');
    var input = wrap.querySelector('.header-search__input');
    var form = wrap.querySelector('.header-search__form');
    if (!toggle || !input) return;

    function open() {
      wrap.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      setTimeout(function () { input.focus(); }, 150);
    }
    function close() {
      wrap.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
    toggle.addEventListener('click', function (e) { e.stopPropagation(); open(); });
    // Close on outside click
    document.addEventListener('click', function (e) {
      if (wrap.classList.contains('is-open') && !wrap.contains(e.target)) close();
    });
    // Close on Escape
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); toggle.focus(); } });
    // Don't submit empty
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!input.value.trim()) { e.preventDefault(); input.focus(); }
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderSearch);
  } else {
    initHeaderSearch();
  }
})();

/* ── Collection grid/list view toggle (v1.4.0) ─────────────────── */
(function () {
  'use strict';
  var KEY = 'mp_view_pref';
  function initViewToggle() {
    var toggle = document.querySelector('[data-view-toggle]');
    var grid = document.getElementById('product-grid');
    if (!toggle || !grid) return;
    var btns = toggle.querySelectorAll('.view-toggle__btn');

    function apply(view) {
      grid.classList.toggle('product-grid--list', view === 'list');
      btns.forEach(function (b) {
        var on = b.getAttribute('data-view') === view;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', String(on));
      });
      try { localStorage.setItem(KEY, view); } catch (e) {}
    }

    btns.forEach(function (b) {
      b.addEventListener('click', function () { apply(b.getAttribute('data-view')); });
    });

    // Restore saved preference
    var saved;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    if (saved === 'list') apply('list');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initViewToggle);
  } else {
    initViewToggle();
  }
})();

/* ── Back-to-top + reading progress (v1.4.3) ───────────────────── */
(function () {
  'use strict';
  function init() {
    var btn = document.getElementById('back-to-top');
    // Reading progress bar — only on long content pages
    var progress = document.createElement('div');
    progress.className = 'read-progress';
    progress.setAttribute('aria-hidden', 'true');
    document.body.appendChild(progress);

    if (btn) btn.hidden = false;

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        var pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
        progress.style.width = pct + '%';
        if (btn) btn.classList.toggle('is-visible', scrollTop > 600);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    if (btn) {
      btn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ── Animated stat counters (v1.4.3) ───────────────────────────── */
(function () {
  'use strict';
  function init() {
    var stats = document.querySelectorAll('.stat-item__value');
    if (!stats.length || !('IntersectionObserver' in window)) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return; // respect reduced-motion: leave static values

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        obs.unobserve(el);
        var raw = el.textContent.trim();
        // Parse a leading integer; keep any suffix (e.g. "+", "k") and skip non-numeric (e.g. "Sa2 ½")
        var m = raw.match(/^(\d+)(\D*)$/);
        if (!m) return; // non-numeric stat — leave as-is
        var target = parseInt(m[1], 10);
        var suffix = m[2] || '';
        if (target <= 0) return;
        var dur = 1100, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3); // ease-out cubic
          el.textContent = Math.round(eased * target) + suffix;
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = target + suffix;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });

    stats.forEach(function (s) { obs.observe(s); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ── Section anchor aliases ─────────────────────────────────────────
   OS 2.0 wraps sections as id="shopify-section-template--X__<key>".
   Menu links target #<key> (e.g. /pages/about#about-timeline), so alias
   every section key as a real anchor, then honour the URL hash. */
(function () {
  document.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) {
    var key = el.id.split('__')[1];
    if (key && !document.getElementById(key)) {
      var a = document.createElement('span');
      a.id = key;
      a.style.cssText = 'position:relative;top:-96px;display:block;height:0;';
      el.parentNode.insertBefore(a, el);
    }
  });
  if (location.hash) {
    var t = document.getElementById(location.hash.slice(1));
    if (t) setTimeout(function () { t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
  }
})();

/* ── Sticky header measurements ──
   Sets --pre-nav-h (announcement + utility height above the nav) and
   --nav-h (main nav height) so the header pins exactly at the nav row
   and sticky sub-bars sit directly beneath it. */
(function () {
  var nav = document.getElementById('mp-header');
  if (!nav) return;
  function measure() {
    var section = nav.closest('[id^="shopify-section"]') || nav.parentElement;
    var pre = nav.getBoundingClientRect().top - section.getBoundingClientRect().top;
    document.documentElement.style.setProperty('--pre-nav-h', Math.max(0, Math.round(pre)) + 'px');
    document.documentElement.style.setProperty('--nav-h', Math.round(nav.offsetHeight) + 'px');
  }
  measure();
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);
})();
